// extracted by mini-css-extract-plugin
module.exports = {"hideAtMobile":"annual-toggle_hideAtMobile__a2ZTG","button":"annual-toggle_button__1D-2U","copy":"annual-toggle_copy__8Dxgs"};